import * as yup from "yup";

// export const OLD_X_API_KEY = "f56f2311-6905-4a70-afbc-d99a5bcac1d5";
export const X_API_KEY = "f56f1011-7905-4a80-afbc-d69a5bcac1d5";

export const VALIDATION_SCHEMA = yup.object().shape({
  searchQuery: yup
    .string()
    .required("Mobile number is required to search")
    .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits"),
  // vpsTaxId: yup.string().required("Please select an option"),
  name: yup
    .string()
    .matches(/^[A-Za-z ]+$/, "Name should only contain letters and 1 space")
    .min(2, "Name should be at least 2 characters long")
    .max(60, "Name should not exceed 60 characters")
    .required("Name is required"),
  email: yup
    .string()
    .required("Email is required")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email address"
    ),
  imeiNumber: yup
    .string()
    .matches(/^[0-9]{15}$/, "Invalid IMEI number")
    .required("IMEI number is required"),
});

export const ALLOWED_USER = [
  {
    email: "apb.admin@acrossassist.com",
    password: "Admin@#$&0325",
    type: "Admin",
  },
  {
    email: "apb.lobs@acrossassist.com",
    password: "Business@#$&0325",
    type: "Business",
  },
  {
    email: "apb.developer@acrossassist.com",
    password: "Developer@#$&0325",
    type: "SuperAdmin",
  },
];
